<template>
  <router-view></router-view>
</template>

<script>
	export default {
		name: "customLabel"
	}
</script>

<style scoped>

</style>
